module.exports = __webpack_public_path__ + "img/selected1-min.74256154.png";